import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Table,
  Button,
  Badge,
} from 'reactstrap';
import { userList } from '../../redux/actions/user';
import { useNavigate  } from 'react-router-dom'
import Loading from '../../components/Loading/Loading';

const UsersTab = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const usersState = useSelector((state) => state.user);
  const users = usersState?.data || [];
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(userList());
  }, [dispatch]);

  useEffect(() => {
    if (usersState?.data) {
      setLoading(false);
    }
  }, [usersState?.data]);

  const handleEdit = (user) => {
    navigate('/create-user', { state: { data: user } });
  };

  const getRoleBadgeColor = (role) => {
    switch (role) {
      case 'admin':
        return 'danger';
      case 'vendedor':
        return 'primary';
      case 'operador':
        return 'warning';
      default:
        return 'secondary';
    }
  };

  if (loading) return <Loading />;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Usuarios del sistema</h5>
        <Button
          color="success"
          size="sm"
          onClick={() => navigate('/create-user')}
        >
          + Crear Usuario
        </Button>
      </div>
      <Table responsive hover>
        <thead>
          <tr>
            <th>Email</th>
            <th>Nombre</th>
            <th>Teléfono</th>
            <th>Rol</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={index}>
              <td>{user.email}</td>
              <td>{user.name}</td>
              <td>{user.phone}</td>
              <td>
                <Badge color={getRoleBadgeColor(user.role_name)}>
                  {user.role_name}
                </Badge>
              </td>
              <td>
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => handleEdit(user)}
                >
                  Editar
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default UsersTab;
